define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"csi/_base/modules",
	"csi/def/Field",
	"csi/form/Widget",
	"csi/locale",
	"csi/message",
	"csi/reflection",
	"csi/resolver",
	"csi/sessionActions",
	"csi/state/rootStore",
	"csi/sessionConstants",
	"csi/xml"
], function(declare,lang,Memory,modules,Field,Widget,locale,message,reflection,resolver,sessionActions,{ sessionStore },sessionConstants,xml) {

	var BULLET_POINT = "\n\u2022 ";
	var AUTH_TYPE = "AuthType";

	/** @property {Object} _authTypesMap - Maps service auth type string to the authtype cnl */
	const _authTypesMap = {
		["standard"]: "centric://REFLECTION/INSTANCE/AuthenticationType/Standard",
		["oauth2service"]: "centric://REFLECTION/INSTANCE/AuthenticationType/OAuth2Service",
	};

	return declare(Widget, {
		_authTypes: null,

		_resolveView: function() {
			this.inherited(arguments);
			// If parent CompanyInfo is Inactive Active Flag on UserCreation active checkbox will be disabled
			var parent = this.defView.getSource().getParent()
			if (parent && parent.Active == false) {
				this.setFieldDisabled("Active", true);
			}

			const {serviceAccountAuthenticationTypesEnabled} = sessionConstants;
			this._authTypes = serviceAccountAuthenticationTypesEnabled.split(",");
			this.addDefaultValue(AUTH_TYPE, _authTypesMap[this._authTypes[0].toLowerCase().trim()]);
		},

		/**
		 * @override
		 * Populate the type and attribute dropdowns in the add attribute placeholder form
		*/
		getFieldStore: function(field, value) {
			if (field.getControlName() == AUTH_TYPE) {

				const numTypes = this._authTypes.length;
				var types = [];

				function add(id, name) {
					types.push({id, name: locale.resource("Authentication"+name.toUpperCase())});
				}

				if (numTypes > 0) {
					for (i = 0; i < numTypes; i++) {
						const type = this._authTypes[i].toLowerCase().trim();
						add(_authTypesMap[type], type);
					}
				} else {
					add(_authTypesMap["standard"], "AuthenticationSTANDARD");
				}
				return new Memory({data: types});
			}
			return this.inherited(arguments);
		},

		_buildView: function() {
			// both the current user and user being edited must be Administrator
			if (sessionConstants.userUrl == xml.ADMIN_USER && this.urlRoot == xml.ADMIN_USER) {
				this.invalidNode.set("value", locale.resource("Change_Admin_Password_Warning"));

				//This text needs to be bolded
				this.invalidNode.valueNode.insertAdjacentHTML("afterbegin", locale.resource("Before_Change_Admin_Password_Warning"));
			}

			this.inherited(arguments);
		},

		errorForm: function(/*String*/errMessage, /*String*/errCode) {
			// summary: focus on field with error and display error message

			//The account is now locked, so kick the user back to the login page
			if (errCode == "SRV_ERR_SiteAdmin_TOO_MANY_FAILED_ATTEMPTS") {
				message.errorDialog({
					message: errMessage,
					onResponse: function() {
						sessionActions.logoutAction();
					}
				});
				return true;
			} else if (errCode == "SRV_ERR_SiteAdmin_NEW_PASSWORD_MUST_BE_DIFFERENT") {
				errMessage = locale.resource("Validation_New_Password_Must_Be_Different");
				return this.inherited(arguments);
			} else {
				return this.inherited(arguments);
			}
		},

		onValidatePassword: function(formView, fieldPassword, value, params) {
			// summary: validate that password does not equal the user id (skipping now since more general now - p/w cannot contain u/n)
			//if (value == formView.getFieldValue("UserID"))
			//	throw new Error(locale.resource("USERNAME_PASSWORD_NOT_UNIQUE"));

			let errorString = "";
			const userID = sessionStore.currentUser.UserID;

			if (userID && value.toLowerCase().includes(userID.toLowerCase()))
				errorString += BULLET_POINT + locale.resource("SRV_ERR_SiteAdmin_PASSWORD_NOT_CONTAIN_USERNAME");

			if (formView.getFieldValue("FirstName") && value.toLowerCase().includes(formView.getFieldValue("FirstName").toLowerCase()))
				errorString += BULLET_POINT + locale.resource("SRV_ERR_SiteAdmin_PASSWORD_NOT_CONTAIN_FIRSTNAME");

			if (formView.getFieldValue("LastName") && value.toLowerCase().includes(formView.getFieldValue("LastName").toLowerCase()))
				errorString += BULLET_POINT + locale.resource("SRV_ERR_SiteAdmin_PASSWORD_NOT_CONTAIN_LASTNAME");

			// get password parameters from CompanyInfo
			const companyInfo = resolver.resolveNode(reflection.URL_COMPANY);

			if (value.length < companyInfo.PasswordMinLength)
				errorString += BULLET_POINT + locale.resource("SRV_ERR_SiteAdmin_PASSWORD_MIN_LENGTH",[companyInfo.PasswordMinLength]);
			if (value.length > companyInfo.PasswordMaxLength)
				errorString += BULLET_POINT + locale.resource("SRV_ERR_SiteAdmin_PASSWORD_MAX_LENGTH",[companyInfo.PasswordMaxLength]);
			if (companyInfo.PasswordRequireUpperCase && !/[A-Z]/.test(value))
				errorString += BULLET_POINT + locale.resource("SRV_ERR_SiteAdmin_PASSWORD_REQUIRE_UPPER_CASE");
			if (companyInfo.PasswordRequireLowerCase && !/[a-z]/.test(value))
				errorString += BULLET_POINT + locale.resource("SRV_ERR_SiteAdmin_PASSWORD_REQUIRE_LOWER_CASE");
			if (companyInfo.PasswordRequireNumeric && !/[0-9]/.test(value))
				errorString += BULLET_POINT + locale.resource("SRV_ERR_SiteAdmin_PASSWORD_REQUIRE_NUMERIC");
			if (companyInfo.PasswordRequireSpecial && !/[^0-9A-Za-z]/.test(value))
				errorString += BULLET_POINT + locale.resource("SRV_ERR_SiteAdmin_PASSWORD_REQUIRE_SPECIAL");

			if (errorString.length > 0) {
				errorString = locale.resource("Validation_Contains_Errors") + errorString;
			}

			throw new Error(errorString);
		},

		onValidateConfirmPassword: function(formView, fieldPassword, value, params) {
			// summary: validate that confirm password equals password when value is complete
			if (!params.bSubset) {
				if (value != formView.getFieldValue("Password")) {
					throw new Error(locale.resource("PASSWORD_MISMATCH"));
				}
			}
		}
	});
});